export default "__VITE_ASSET__Cslsbiwm__"